module.exports = __webpack_public_path__ + "img/vulcao.b19e73b1.png";